/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 14,
    height: 15,
    viewBox: '0 0 14 15',
    data: '<g _fill="#C7C7C7"><path pid="0" d="M3 4h6v1H3zM3 7h2v1H3zM3 10h1v1H3z"/><path pid="1" d="M1.5 1.5h9v3.428H12V0H0v14h4.679v-1.5H1.5z"/><path pid="2" d="M13.889 13.475l-1.149-1.149a4 4 0 1 0-.618.796l1.061 1.061a.5.5 0 1 0 .706-.708zm-2.475-1.061a3 3 0 1 1-4.243-4.241 3 3 0 0 1 4.243 4.241z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/check.js